import { BlockEnum } from '../../common/enum';
import { BookDTO, PageDTO } from './apiType';

export interface PaginationEdge<Item = any> {
  cursor: string;
  item: Item;
}

export interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface PaginationConnection<Item = any> {
  totalCount: number;
  list: PaginationEdge<Item>[];
  pageInfo: PageInfo;
}

export interface Pagination<Schema> {
  list: Schema;
}

export interface VerificationForm {
  email: string;
  otpCode: string;
  expiredTime?: Date;
  fromPage?: string;
  password?: string;
}

export interface SignUpForm {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmationPassword: string;
  countryCode: string;
  phone: string;
  phoneCode?: string;
  isAgree?: boolean;
  subscribeNewsletter?: boolean;
}

export interface Asset {
  key: string;
  tags: {
    asset_class: string;
    asset_group: string;
    asset_type: string;
    display_order: string;
    keywords: string;
    scalable: string;
    transformations: string;
  };
}

export interface ShapeResource {
  id: string;
  name: string;
  list: string[];
  thumbnail?: string;
}

export interface StickerResource {
  id: string;
  name: string;
  list: string[];
  thumbnail?: string;
}

export interface AssetResource {
  id: string;
  name: string;
  list: string[];
  thumbnail?: string;
}
export enum ShapeType {
  BASIC_SHAPES = 'BASIC_SHAPES',
}

export enum Transformations {
  LAYER = 'layer',
  POSITION = 'position',
  LINE = 'line',
  BORDER = 'border',
  FILL = 'fill',
  LINE_END = 'line-end',
}

export enum SyncStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}

export enum HistoryActionEnum {
  UNDO = 'UNDO',
  REDO = 'REDO',
  UPDATE = 'UPDATE',
}

export interface BookHistory extends BookDTO {
  pages: PageDTO[];
}

export interface Option<T> {
  value: T;
  label: string;
}

export interface CopiedBlockStyle {
  id: string;
  type: BlockEnum;
  styles: string;
}
